import { c as _c } from "react/compiler-runtime";
import type { SanityImageObject } from "@sanity/image-url";
import styles from "./FundraiserHeader.module.scss";
import { ResponsiveImage } from "../../../shared/responsiveimage";
export const FundraiserHeader: React.FC<{
  headerImage: SanityImageObject;
  fundraiserImage: SanityImageObject;
}> = t0 => {
  const $ = _c(7);
  const {
    headerImage,
    fundraiserImage
  } = t0;
  let t1;
  if ($[0] !== headerImage) {
    t1 = <div className={styles.headerimage}><ResponsiveImage image={headerImage} alt="Header image" layout="cover" priority={true} /></div>;
    $[0] = headerImage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== fundraiserImage) {
    t2 = <div className={styles.fundraiserimage}><ResponsiveImage image={fundraiserImage} alt="Fundraiser image" layout="cover" priority={true} /></div>;
    $[2] = fundraiserImage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={styles.header}>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};